import React, { useState } from 'react';
import { Eye, EyeOff, Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { Wordmark } from '../components/layout/AppShell';

const HERO = 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=1600&q=70';

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try { await login(email, password); } catch (err) { setError(err.status === 401 ? 'Incorrect email or password.' : err.message); } finally { setBusy(false); }
  };

  return (
    <div className="auth">
      <section className="auth__hero" style={{ backgroundImage: `linear-gradient(180deg, #0a1a26b3, #0a1a2666 45%, #0a1a26cc), url(${HERO})` }}>
        <div className="auth__band"><Wordmark height={34} /></div>
        <small style={{ color: '#c6d4de' }}>Photo: Unsplash</small>
      </section>
      <section className="auth__panel">
        <form className="auth__card" onSubmit={submit}>
          <div>
            <h1 style={{ fontSize: 26 }}>Sign in</h1>
            <p className="muted" style={{ marginTop: 4 }}>Greenhouse monitoring</p>
          </div>
          <div className="field"><label htmlFor="email">Email</label>
            <input id="email" className="input" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} autoFocus /></div>
          <div className="field"><label htmlFor="pw">Password</label>
            <div style={{ position: 'relative' }}>
              <input id="pw" className="input" type={show ? 'text' : 'password'} autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} style={{ paddingRight: 44 }} />
              <button type="button" className="btn icon ghost sm" onClick={() => setShow(!show)} aria-label={show ? 'Hide password' : 'Show password'} style={{ position: 'absolute', right: 4, top: 4 }}>{show ? <EyeOff size={16} /> : <Eye size={16} />}</button>
            </div>
          </div>
          {error && <div className="badge crit" role="alert" style={{ height: 'auto', padding: '8px 12px', borderRadius: 2, whiteSpace: 'normal' }}>{error}</div>}
          <button className="btn primary" style={{ height: 42, fontSize: 14 }} disabled={busy}>{busy ? <><Loader2 size={16} style={{ animation: 'spin 1s linear infinite' }} /> Signing in</> : 'Sign in'}</button>
          <p className="faint small">Contact an administrator if you need an account.</p>
        </form>
      </section>
    </div>
  );
}
